import React from 'react';
import CTAButton from './CTAButton';
export function SolutionSection() {
  return <section className="py-6 px-4 bg-white" data-id="element-277">
      <div className="max-w-4xl mx-auto" data-id="element-278">
        <div className="bg-green-50 p-5 rounded-lg shadow-lg mb-4" data-id="element-279">
          <h2 className="text-3xl md:text-5xl font-black text-green-600 mb-3 text-center" data-id="element-280">
            💡 PERO ESTO PUEDE CAMBIAR
          </h2>
          <p className="text-xl text-center mb-2" data-id="element-281">Y empieza en casa.</p>
          <p className="text-xl text-center mb-2" data-id="element-282">No en la escuela.</p>
          <p className="text-xl text-center mb-2" data-id="element-283">No en internet.</p>
          <p className="text-2xl font-bold text-center" data-id="element-284">👉 Contigo.</p>
        </div>

        <div className="bg-gradient-to-r from-yellow-400 to-orange-500 p-6 rounded-lg shadow-2xl mb-4" data-id="element-285">
          <h2 className="text-3xl md:text-5xl font-black text-white mb-3 text-center" data-id="element-286">
            🚀 PRESENTAMOS:
          </h2>
          <h3 className="text-4xl md:text-6xl font-black text-white mb-3 text-center" data-id="element-287">
            🎓 EDUCACIÓN FINANCIERA DESDE CASA
          </h3>
          <p className="text-xl md:text-2xl text-white text-center font-bold" data-id="element-288">
            Un sistema práctico, simple y probado para enseñar a tus hijos a
            manejar el dinero desde pequeños
          </p>
        </div>

        <div className="bg-white p-5 rounded-lg shadow-lg mb-4" data-id="element-289">
          <h3 className="text-2xl md:text-4xl font-black text-gray-800 mb-3" data-id="element-290">
            🧠 ¿QUÉ HACE DIFERENTE A ESTE SISTEMA?
          </h3>
          <p className="text-xl mb-2" data-id="element-291">No es teoría complicada.</p>
          <p className="text-xl mb-2" data-id="element-292">No es aburrido.</p>
          <p className="text-xl font-bold mb-2" data-id="element-293">
            👉 Es un sistema diseñado para padres reales
          </p>
          <p className="text-xl font-bold mb-2" data-id="element-294">con hijos reales</p>
          <p className="text-xl font-bold" data-id="element-295">y poco tiempo.</p>
        </div>

        <div className="bg-blue-50 p-5 rounded-lg shadow-lg mb-4" data-id="element-296">
          <h3 className="text-2xl md:text-4xl font-black text-blue-600 mb-3" data-id="element-297">
            👨‍👩‍👧 EN POCAS PALABRAS
          </h3>
          <ul className="space-y-2" data-id="element-298">
            <li className="flex items-start" data-id="element-299">
              <span className="text-blue-600 font-bold mr-3" data-id="element-300">👉</span>
              <span className="text-xl" data-id="element-301">Aprenderán jugando</span>
            </li>
            <li className="flex items-start" data-id="element-302">
              <span className="text-blue-600 font-bold mr-3" data-id="element-303">👉</span>
              <span className="text-xl" data-id="element-304">Aplicarán en casa</span>
            </li>
            <li className="flex items-start" data-id="element-305">
              <span className="text-blue-600 font-bold mr-3" data-id="element-306">👉</span>
              <span className="text-xl" data-id="element-307">Desarrollarán hábitos reales</span>
            </li>
          </ul>
        </div>

        <CTAButton text="¡QUIERO TRANSFORMAR A MI HIJO!" data-id="element-308" />
      </div>
    </section>;
}
export default SolutionSection;